export class Constants {
  static COUNTRY_CODE = '356';
  static BANK_COUNTRY_CODE = 'MT';

  static SEPA_COUNTRIES_CODE = [
    'AL',
    'AD',
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MC',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SM',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'GB',
    'VA',
  ];
}
